import propType from 'prop-types';
import React from 'react';

import BravoBreadcrumb from '../../../../components/BravoBreadcrumb';

const ArticleBreadcrumb = ({ title, breadcrumb }) => {
  const routesList = [...breadcrumb, { text: title }];

  return (
    <BravoBreadcrumb className="article-breadcrumb" breadcrumb={routesList} />
  );
};

ArticleBreadcrumb.propTypes = {
  title: propType.string.isRequired,
  breadcrumb: propType.arrayOf(
    propType.shape({
      text: propType.string.isRequired,
      url: propType.string.isRequired
    })
  ).isRequired
};

export default ArticleBreadcrumb;
